import { useContext } from 'react';
import { AccountFormContext } from './AccountFormProvider';

export const useAccountFormContext = () => {
  const context = useContext(AccountFormContext);
  if (context === undefined) {
    throw new Error('useAccountFormContext must be used within a AccountFormProvider');
  }
  return context;
};
